import dataSources from 'dataSources';
import { IStationInfo } from 'dataSources/Typicode/stations';
import { useCallback, useState } from 'react';

export const useLoadStationInformation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [stationInfo, setStationInfo] = useState<IStationInfo | null>(null);

  const loadingStationInfo = useCallback(async (stationCode: string) => {
    try {
      setIsLoading(true);
      const info = await dataSources.stations.getStationInfo(stationCode);
      setStationInfo(info);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, []);
  return {
    loadingStationInfo,
    isLoading,
    stationInfo,
  };
};
